import React from "react";
//import { DASH_PATH_DELIMITER_UI, FilterContext, AddFilterBaseFunc, RemoveFilterBaseFunc } from "models/dashboard/core";
import { IHierarchyPlotData } from "models/core/hierarchy";
import { AddFilterBaseFunc, DASH_PATH_DELIMITER_UI, FilterContext, RemoveFilterBaseFunc } from "models/core/filter";

interface IProps {
    data: IHierarchyPlotData<any>;
    filterKey: string;
    addFilter: AddFilterBaseFunc<any>;
    removeFilter: RemoveFilterBaseFunc<any>;
}

/**
 * Component to display the path of the current hierarchy position.
 * Supports navigation and filtering back up the hierarchy.
 */
export class HierarchyBreadcrumb extends React.Component<IProps, {}> {

    constructor(props) {
        super(props);
    }

    /**
     * 
     * @param p Value 
     * @param partIndex 
     */
    private addHierarchyFilterFactory = (p: string, partIndex: number) => {
        const { data, filterKey, addFilter } = this.props;
        const { path } = data;

        const context = path && FilterContext.fromPath(path) || new FilterContext();
        const ancestor = context.ancestor(partIndex + 1) || new FilterContext();

        return addFilter(filterKey, [p], ancestor);
    }

    render = () => {
        const { data, filterKey, removeFilter } = this.props;
        const context = FilterContext.fromPath(data.path);
        const parts = context.parts;
        const valuesLabel = context.valuesLabel().replace(`[`, ``).replace(`]`, ``);

        if (data && data.path) {
            return (
                <div className="dash-breadcrumb">
                    <span><a onClick={_ => removeFilter(filterKey)}>All</a> / </span>
                    {parts.map((p, i) => {
                        if (i !== parts.length - 1) {
                            return <span key={i}><a onClick={_ => this.addHierarchyFilterFactory(p, i)} >{p}</a>{DASH_PATH_DELIMITER_UI}</span>;
                        } else {
                            return <span key={i}>{valuesLabel}</span>;
                        }
                    })}
                </div>
            );
        }

        return (<div className="dash-breadcrumb">&nbsp;</div>);
    }
}